export const BASE_URL = import.meta.env.VITE_API_URL;
export const NFC_SERVICE_URL = import.meta.env.VITE_NFC_SERVICE_WS_URL